import cx from 'clsx';
import { format } from 'date-fns';
import React from 'react';

import { ReactComponent as CopyIcon } from '@assets/svg/copyIcon.svg';
import { ReactComponent as ChatIcon } from '@assets/svg/ic-chat.svg';
import { ReactComponent as ResendIcon } from '@assets/svg/ic-resend.svg';

import useTranslation from '@hooks/useTranslation';

import type { IChatMessage } from '../../model/chatMessage';
import style from './style.module.scss';

interface IProps {
  messageItem: IChatMessage;
  userImage: string;
  dateTimeFormat: string;
  tooltipId: string;
  sendMessage: (content: string) => void;
  handleCopyMessage: (message: string) => void;
}

const ChatMessage: React.FC<IProps> = ({
  messageItem,
  userImage,
  dateTimeFormat,
  tooltipId,
  sendMessage,
  handleCopyMessage,
}) => {
  const { t } = useTranslation();

  const isUserMessage = messageItem.role === 'user';
  const showCopy = !isUserMessage && !messageItem.firstMessage;

  return (
    <div
      id={`${messageItem.id || ''}`}
      className={cx(style.messageItem, {
        [style.userMessage]: isUserMessage,
        [style.errorMessage]: messageItem.hasError,
      })}
    >
      <div className={style.messageHead}>
        {isUserMessage ? (
          <img src={userImage} className={style.userAvatar} alt="user" />
        ) : (
          <ChatIcon className={style.assistantIcon} />
        )}
        {messageItem.createdAt && (
          <div className={style.messageDateTime}>{format(messageItem.createdAt, dateTimeFormat)}</div>
        )}
      </div>
      <div className={style.messageText} dangerouslySetInnerHTML={{ __html: messageItem.content || '' }} />
      {(showCopy || messageItem.hasError) && (
        <div className={style.messageActions}>
          {showCopy && (
            <CopyIcon
              className={style.copyIcon}
              data-tooltip-id={tooltipId}
              data-tooltip-content={t('Copy answer')}
              onClick={() => handleCopyMessage(messageItem.content || '')}
            />
          )}
          {messageItem.hasError && (
            <ResendIcon
              data-tooltip-id={tooltipId}
              data-tooltip-content={t('Send again')}
              className={style.messageError}
              onClick={() => sendMessage(messageItem.content)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ChatMessage;
